import { Location } from '@angular/common';
import { Directive, Input, OnDestroy } from '@angular/core';
import { NgModel } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { unsubscribe } from '../../utils/helpers';
import { Subscription } from 'rxjs';
import { IndicatorsService } from './indicators.service';

@Directive({
  standalone: false, selector: '[saveInputValue]' })
export class SaveInputValueDirective implements OnDestroy {

  private readonly subscriptions: Subscription[] = [];

  @Input('saveInputValue') queryParamName: string;

  set value(val: string) {
    this.indicatorsService.set(this.queryParamName, val);

    const queryParams: Params = {
      ...this.activatedRoute.snapshot.queryParams,
      [this.queryParamName]: val,
    };

    if (val === undefined || val === null || val === '') {
      delete queryParams[this.queryParamName];
    }

    const urlTree = this.router.createUrlTree([], {
      queryParams,
      relativeTo: this.activatedRoute,
    });

    this.location.replaceState(this.router.serializeUrl(urlTree));
  }

  constructor(
    private model: NgModel,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private location: Location,
    private indicatorsService: IndicatorsService,
  ) {
    unsubscribe(this.subscriptions);
    this.subscriptions.push(
      this.model.valueChanges.subscribe(val => {
        this.value = val;
      }),
    );
  }

  ngOnDestroy() {
    unsubscribe(this.subscriptions);
  }

}
